import { render, staticRenderFns } from "./CustomerCampaignPaymentCanceled.vue?vue&type=template&id=2f5cf608&"
import script from "./CustomerCampaignPaymentCanceled.vue?vue&type=script&lang=js&"
export * from "./CustomerCampaignPaymentCanceled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports